<template>
  <span v-if="props.status === 0" class="badge bg-warning text-dark"><font-awesome-icon :icon="['fas', 'hourglass-end']" fixed-width /> <span v-if="props.showText">{{ $t('status.pending') }}</span></span>
  <span v-else-if="props.status === 1" class="badge bg-info"><font-awesome-icon :icon="['fas', 'clipboard']" fixed-width /> <span v-if="props.showText">{{ $t('status.inProgress') }}</span></span>
  <span v-else-if="props.status === 2" class="badge bg-success"><font-awesome-icon :icon="['fas', 'check']" fixed-width /> <span v-if="props.showText">{{ $t('status.completed') }}</span></span>
  <span v-else-if="props.status === 3" class="badge bg-danger"><font-awesome-icon :icon="['fas', 'xmark']" fixed-width /> <span v-if="props.showText">{{ $t('status.orderCancelledShort') }}</span></span>
  <span v-else class="badge bg-danger"><font-awesome-icon :icon="['fas', 'trash']" fixed-width /> <span v-if="props.showText">{{ $t('status.failed') }}</span></span>
</template>

<script setup lang="ts">
const props = defineProps({
  status: { type: Number, required: true },
  showText: { type: Boolean, required: false, default: true }
});
</script>
